<template>
    <div class="service-enquiries">
        <h6 class="font-weight-bold my-3">Helpline Engagement: Online Enquiries</h6>
        <div class="d-flex flex-row justify-content-center report-summary mb-3">
            <div class="counter p-2 flex-fill text-center">
                <h2>{{ enquiries.all.total }}</h2>
                <p>Total Enquiries</p>
            </div>
            <div class="counter p-2 flex-fill text-center">
                <h2>{{ enquiries.month.total }}</h2>
                <p>This Month</p>
            </div>

            <div v-if="services.length > 1" v-for="service in services" class="counter p-2 flex-fill text-center">
                <h2>{{ enquiries.month.services[service['site_id']]['total'] }} <span class="text-muted">|</span> {{ enquiries.all.services[service['site_id']]['total'] }}</h2>
                <p>{{ service.name }}<br><small class="text-muted" style="font-size: 0.65em;">Month | Total</small></p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "ReportEnquiries",
        props: ['enquiries','services']
    }
</script>

<style scoped>

</style>
